'use client'

import { Suspense, useState } from 'react'
import YouTube, { YouTubeProps } from 'react-youtube'
import { SanityImageAssetDocument } from 'next-sanity'
import { SanityImage } from '@otomoro/components/shared/SanityImage'
import { AppText } from '@otomoro/components/shared/AppText'
import { PlayIcon } from '@otomoro/components/icons'
import clsx from "clsx"

type YoutubeVideoProps = {
	className?: string
	placeholder?: SanityImageAssetDocument
	backgroundColor?: string
	noPadding?: boolean
	caption?: string
	videoId?: string
	setExternalVideoElement?: (element: any) => void
}

export function YoutubeVideo({
	className,
	videoId,
	caption,
	placeholder,
	backgroundColor,
	noPadding,
	setExternalVideoElement,
}: YoutubeVideoProps) {
	const [videoElement, setVideoElement] = useState<any>(null)
	const [playing, setPlaying] = useState(false)
	const [canPlayThrough, setCanPlayThrough] = useState(false)

	const handleClick = () => {
		if (videoElement) {
			setPlaying(true)
			videoElement.playVideo()
		}
	}

	const handleEnded = () => {
		setPlaying(false)
	}

	const onCanPlay = (e: any) => {
		setVideoElement(e.target)
		typeof setExternalVideoElement === 'function' && setExternalVideoElement(e.target)
		setCanPlayThrough(true)
	}

	const handleStateChange = (e: any) => {
		const playerState = e.target.getPlayerState()
		const stoppedStates = [0, -1, 5, 2]
		setPlaying(!stoppedStates.includes(playerState))
	}

	return (
		<div
			className={clsx(
				"",
				className,
				noPadding ? 'noPadding' : undefined,
				playing ? 'playing' : undefined
			)}
			style={{ backgroundColor }}
		>
			<div
				className=""
				style={{
					aspectRatio: '16/9',
				}}
			>
				{/* {placeholder && (
					<div className='placeholder'>
						<SanityImage image={placeholder} className="placeholderImage" alt="" />
						<button onClick={handleClick} className="trigger" disabled={!canPlayThrough}>
							<span className="triggerInner">
								<PlayIcon className="triggerIcon" />
								<AppText
									as="span"
									className="triggerText"
									color="white"
								>
									Play video
								</AppText>
							</span>
						</button>
					</div>
				)} */}
				<Suspense fallback={null}>
					<YouTube
						videoId={videoId}
						className="videoStyle"
						iframeClassName="iframeStyle w-full h-full aspect-[16/9]"
						title={caption}
						onStateChange={handleStateChange}
						onReady={onCanPlay}
						onEnd={handleEnded}
					/>
				</Suspense>
			</div>
		</div>
	)
}
